import { render, staticRenderFns } from "./CanvasMap.vue?vue&type=template&id=629c03ec&"
import script from "./CanvasMap.vue?vue&type=script&lang=js&"
export * from "./CanvasMap.vue?vue&type=script&lang=js&"
import style0 from "./CanvasMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports